import { SET_STORES, SET_STORES_ERROR, SET_STORES_LOADING, SET_STORE_SETTING } from "../../actions/storeAction";

const initialState = {
  datas: null,
  setting: null,
  loading: false,
  error: null,
};

const storeReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_STORES:
      return { ...state, datas: action.data, error: null };
    case SET_STORE_SETTING:
      return { ...state, setting: action.data, error: null };
    case SET_STORES_LOADING:
      return { ...state, loading: action.status };
    case SET_STORES_ERROR:
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
};

export default storeReducer;
